import { createSlice } from '@reduxjs/toolkit';
export const initialState = {
    request: {
        isSaving: false,
        isConfirmed: false,
        error: null,
    },
};
export const candidateAvailabilitySlice = createSlice({
    name: 'candidateAvailability',
    initialState,
    reducers: {
        addScheduleOverrideRequest(state, _action) {
            state.request.isSaving = true;
            state.request.error = null;
        },
        addScheduleOverrideSuccess(state) {
            state.request.isSaving = false;
            state.request.isConfirmed = true;
            state.request.error = null;
        },
        addScheduleOverrideFailure(state) {
            state.request.isSaving = false;
        },
    },
});
export const { addScheduleOverrideRequest, addScheduleOverrideSuccess, addScheduleOverrideFailure } = candidateAvailabilitySlice.actions;
export default candidateAvailabilitySlice.reducer;
